export default __webpack_public_path__ + "static/media/card.455506a4.png";